import { useQuery } from "@tanstack/react-query";
import { statsRepo } from "@/lib/repositories";
import type { StatsParams } from "../types";

export function useDilemmasPerTopic({
  end_date,
  limit,
  offset,
  start_date,
}: StatsParams) {
  const query = useQuery({
    queryKey: ["stats", "dilemmas-per-topic"],
    queryFn: () =>
      statsRepo.fetchDilemmasPerTopic({
        end_date,
        limit,
        offset,
        start_date,
      }),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
  };
}
